/* Cartec Essentials — winkelwagen-feedback.
   Toont een korte bevestiging ("Toegevoegd aan winkelwagen") zodra het aantal
   in de winkelwagen-teller toeneemt. Werkt onafhankelijk van interne events:
   observeert de teller die het <cart-icon>-component live bijwerkt. */
(function () {
  function countEl() {
    return (
      document.querySelector('.ce-header__cart-icon .cart-bubble__text-count') ||
      document.querySelector('.cart-bubble__text-count')
    );
  }
  function parseCount(el) {
    if (!el) return 0;
    var n = parseInt((el.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  var toast, hideTimer;
  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'ce-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="ce-toast__icon" aria-hidden="true">✓</span>' +
      '<span class="ce-toast__msg">Toegevoegd aan winkelwagen</span>' +
      '<button type="button" class="ce-toast__btn" data-ce-toast-view>Bekijk</button>' +
      '<button type="button" class="ce-toast__close" aria-label="Sluiten">×</button>';
    document.body.appendChild(toast);
    toast.addEventListener('click', function (e) {
      if (e.target.closest('[data-ce-toast-view]')) {
        hide();
        var trigger = document.querySelector('.ce-header__cart');
        if (trigger) trigger.click();
      } else if (e.target.closest('.ce-toast__close')) {
        hide();
      }
    });
    return toast;
  }
  function show() {
    var t = ensureToast();
    t.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 3500);
  }
  function hide() {
    if (toast) toast.classList.remove('is-visible');
  }

  var armed = false;
  var last = 0;

  // Primair signaal: het standaard cart-event dat bij ELKE AJAX-toevoeging
  // afgaat (productpagina én aanbevelingen). Betrouwbaarder dan een DOM-teller
  // observeren, want die node wordt bij een her-render vervangen.
  function onCartEvent(event) {
    // Het event vuurt optimistisch af, vóór de AJAX klaar is. Wacht daarom op de
    // meegestuurde promise: die resolvet mét de definitieve cart, zodat we niet
    // op een vaste vertraging of de (vervangen) teller-node hoeven te leunen.
    var p = event && event.promise;
    if (p && typeof p.then === 'function') {
      p.then(function (res) {
        var detail = (res && res.detail) || {};
        var cart = (res && res.cart) || {};
        if (detail.didError) return;
        // Toon alleen als het aantal is toegenomen (dus toevoegen, niet verwijderen).
        var now = typeof cart.item_count === 'number' ? cart.item_count : parseCount(countEl());
        if (armed && now > last) show();
        last = now;
      }).catch(function () {});
      return;
    }
    // Vangnet (geen promise): vergelijk na een korte vertraging.
    setTimeout(function () {
      var now = parseCount(countEl());
      if (armed && now > last) show();
      last = now;
    }, 60);
  }

  // Vangnet: observeer de teller zolang die node bestaat (dekt eventuele
  // add-paden die het standaard event niet dispatchen).
  function watch() {
    var el = countEl();
    if (!el) return false;
    new MutationObserver(function () {
      var now = parseCount(el);
      if (armed && now > last) show();
      last = now;
    }).observe(el, { childList: true, characterData: true, subtree: true });
    return true;
  }

  function init() {
    last = parseCount(countEl());

    // Kleine armeer-vertraging zodat de teller-herstelwaarde bij paginalaad
    // (uit sessionStorage) geen valse melding geeft.
    setTimeout(function () { armed = true; }, 1200);

    document.addEventListener('shopify:cart:lines-update', onCartEvent);

    if (watch()) return;
    // Teller nog niet in DOM? Kort pollen tot <cart-icon> gerenderd is.
    var tries = 0;
    var iv = setInterval(function () {
      if (watch() || ++tries > 20) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
